<template><!-- 验收后的退换货记录 -->
  <el-card class="m-b" v-if="isHasThhAfter">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">验收后退换货记录</span>
    </div>
    <zl-server-page-table
      :border="false"
      showTotal
      ref="multipleTable"
      :api="getApi"
      height="400px"
      :columns="columns"
    >
      <!-- template里面写的话会放到columns之后去渲染 -->
      <el-table-column fixed="right" label="操作" min-width="135">
        <template slot-scope="scope">
          <el-link type="primary" @click="skipThhDetail(scope.row)">
            查看
          </el-link>
        </template>
      </el-table-column>
    </zl-server-page-table>
  </el-card>
</template>
<script>
import dayjs from 'dayjs'
import { getValue } from '@/lib/enum'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      dayjs,
      getValue,
      // 退换货表头
      columns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '单号',
          prop: 'thhCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '类型',
          prop: 'thhType',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => getValue('thhType', row.thhType)
        },
        {
          label: '金额(元)',
          prop: 'thAmount',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '提交时间',
          prop: 'submitTime',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.submitTime && dayjs(row.submitTime).format('YYYY-MM-DD hh:mm:ss')
        },
        {
          label: '状态',
          prop: 'status',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => getValue('thhStatus', row.status)
        }
      ],
      isHasThhAfter: true,
      system: this.$store.state.system // 当前登录的是哪个系统
    }
  },
  methods: {
    ...mapActions([
      'pageSubOrderTHHAfter',
      'pageSubOrderTHHAfterGys'
    ]),
    getApi(args) {
      return this[`${this.system === 'purchaser' ? 'pageSubOrderTHHAfter' : 'pageSubOrderTHHAfterGys'}`]({
        subOrderId: this.$route.query.id,
        pageNum: args.page,
        pageSize: args.size
      }).then((res) => {
        this.isHasThhAfter = res.list && res.list.length
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    // 跳至退换货详情页
    skipThhDetail(obj) {
      this.$router.push({
        name: `${this.$store.state.system === 'purchaser' ? 'ReturnDetail' : 'SupplierReturnDetail'}`,
        query: { id: obj.id, type: obj.thhType === 10 ? 'return' : 'exchange', hasBtn: false }
        // params: { isReLoad: true }
      })
    }
  }
}
</script>
